import { render, staticRenderFns } from "./questionSingle.vue?vue&type=template&id=a36a81f0&scoped=true&"
import script from "./questionSingle.vue?vue&type=script&lang=js&"
export * from "./questionSingle.vue?vue&type=script&lang=js&"
import style0 from "./questionSingle.vue?vue&type=style&index=0&id=a36a81f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36a81f0",
  null
  
)

export default component.exports